import type { InsertionOrderRule } from 'c-sdk';
import { InsertionOrderAttribute } from 'c-sdk';
import { describeRule } from './lib';

/**
 * UL-7912 -- how the saved rules list in the Edit Table Parameters dialog reads.
 */

/** A rule's date bound as `from – to`, `…` for an open side, `—` for no bound at all. */
export const formatRuleDateRange = (rule: Pick<InsertionOrderRule, 'date_from' | 'date_to'>) =>
    rule.date_from || rule.date_to
        ? `${rule.date_from?.slice(0, 10) ?? '…'} – ${rule.date_to?.slice(0, 10) ?? '…'}`
        : '—';

/** The whole rule, conditions joined by AND -- with the id itself for a single-id rule (a pick). */
export const ruleIdentifierLabel = (rule: Pick<InsertionOrderRule, 'conditions'>) =>
    `${describeRule(rule)}${
        rule.conditions.length === 1 &&
        rule.conditions[0].parameter === InsertionOrderAttribute.insertionOrderId
            ? ` ${rule.conditions[0].identifier}`
            : ''
    }`;

/** Most-matching first, as the media list is: the rules doing the work lead. */
export const sortRulesByMatches = (rules: InsertionOrderRule[]) =>
    [...rules].sort((a, b) => b.insertion_order_count - a.insertion_order_count);
